// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar__B4xMC","abbr":"abbr__RyS4Q"};